<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap"
  >
    <div
      class="back-mobile-btn"
      @click="goBack(routerBackName, 'referringProvider')"
    >
      <i class="fa fa-arrow-left" />
    </div>
    <h3>
      {{ $t('preCheckIn.referringProvider.title') }}
    </h3>
    <el-form
      :model="referringProvider"
      ref="referringProviderForm"
      :rules="rules"
      class="referring-provider pre-reg"
      label-position="top"
    >
      <el-row class="block">
        <el-row class="title">
          {{ $t('preCheckIn.referringProvider.title') }}
        </el-row>
        <el-row class="data">
          <el-form-item
            :label="$t('common.labels.lastName')"
            prop="lastName"
            :class="[{'focus': referringProvider.lastName || typingName}, 'required-field']"
          >
            <el-autocomplete
              filterable
              clearable
              @select="changeProvider($event)"
              @change="changeData($event)"
              class="full search"
              suffix-icon="el-icon-search"
              :fetch-suggestions="searchProviderNames"
              :debounce="2000"
              placeholder=""
              :loading="loading"
              @focus="focusEvent()"
              @blur="blurEvent()"
              @clear="clearProvider()"
              v-model="referringProvider.lastName"
              ref="autocompleteInput"
              automatic-dropdown="true"
              :trigger-on-focus="false"
              :disabled="referringProvider.noReferringProvider"
            />
            <span
              class="search-data"
              v-if="loading"
            >
              {{ $t('common.labels.search') }} ...
            </span>
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.firstName')"
            prop="firstName"
            :class="[{'focus': referringProvider.firstName}, 'required-field']"
          >
            <el-input
              type="text"
              v-model="referringProvider.firstName"
              :disabled="disableField || referringProvider.noReferringProvider"
            />
          </el-form-item>
        </el-row>
        <el-row class="data">
          <el-form-item
            :label="$t('common.labels.officePhone')"
            prop="officePhone"
            :class="[{'focus': referringProvider.officePhone}, 'required-field']"
          >
            <el-input
              :key="keyMask"
              v-model="referringProvider.officePhone"
              :disabled="disableField || referringProvider.noReferringProvider"
              v-mask="'(###) ###-####'"
            />
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.fax')"
            prop="faxNumber"
            :class="{'focus': referringProvider.faxNumber}"
          >
            <el-input
              :key="keyMask"
              v-model="referringProvider.faxNumber"
              :disabled="disableField || referringProvider.noReferringProvider"
              v-mask="'(###) ###-####'"
            />
          </el-form-item>
        </el-row>
        <el-row class="data full">
          <el-form-item
            :label="$t('common.labels.email')"
            prop="email"
            :class="{'focus': referringProvider.email}"
          >
            <el-input
              type="email"
              v-model="referringProvider.email"
              :disabled="disableField || referringProvider.noReferringProvider"
            />
          </el-form-item>
        </el-row>
        <el-row
          class="data full"
          v-if="typeof referringProvider.address !== 'undefined'"
        >
          <el-form-item
            :label="$t('common.labels.address')"
            prop="address.line1"
            :class="{'focus': referringProvider.address.line1}"
          >
            <el-input
              type="text"
              v-model="referringProvider.address.line1"
              :disabled="disableField || referringProvider.noReferringProvider"
            />
          </el-form-item>
        </el-row>
        <el-row
          class="data addr-data"
          v-if="typeof referringProvider.address !== 'undefined'"
        >
          <el-form-item
            :label="$t('common.labels.city')"
            prop="city"
            :class="[{'focus': referringProvider.address.city}, 'city']"
          >
            <el-input
              type="text"
              v-model="referringProvider.address.city"
              :disabled="disableField || referringProvider.noReferringProvider"
            />
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.state')"
            prop="state"
            :class="[{'focus': referringProvider.address.state}, 'state']"
          >
            <el-select
              filterable
              v-model="referringProvider.address.state"
              :disabled="disableField || referringProvider.noReferringProvider"
              placeholder=""
            >
              <el-option
                v-for="(state, key) in states"
                :key="key"
                :label="state.name"
                :value="state.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.zip')"
            prop="zip"
            :class="[{'focus': referringProvider.address.zip}, 'zip']"
          >
            <el-input
              :key="keyMask"
              v-model="referringProvider.address.zip"
              :disabled="disableField || referringProvider.noReferringProvider"
              v-mask="'#####'"
            />
          </el-form-item>
        </el-row>
        <el-row class="data full">
          <el-form-item
            class="skip-step"
          >
            <el-checkbox
              v-model="referringProvider.noReferringProvider"
              @change="noReferringProvider($event)"
              :disabled="disableField"
            >
              {{ $t('preCheckIn.referringProvider.skip') }}
            </el-checkbox>
          </el-form-item>
        </el-row>
      </el-row>
      <el-form-item
        class="submit-container"
      >
        <el-form-item
          class="submit-buttons"
        >
          <el-button
            @click="goBack(routerBackName,'referringProvider')"
            type="back"
          >
            {{ $t('common.buttons.back') }}
          </el-button>
          <el-row
            class="right-btn"
          >
            <el-button
              type="primary"
              @click="submitForm('referringProviderForm')"
            >
              {{ $t('common.buttons.next') }}
            </el-button>
          </el-row>
        </el-form-item>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import store from "../../store";

export default {
  name: 'ReferringProvider',
  data: () => {
    return {
      states: [],
      referringProvider: {},
      userData: {},
      fullscreenLoading: false,
      patientNumber: null,
      loading: false,
      providerNames: [],
      existProviderData: [],
      updatedUserData: {},
      loadingProvider: false,
      disableField: false,
      activeStep: null,
      typingName: false,
      currentQuery: '',
      list: [],
      keyMask: 0,
      sid: null,
      routerName: 'Questionnaire',
      routerBackName: 'PrimaryCarePhysician',
      rules: {},
      fields: ['firstName', 'lastName', 'officePhone'],
    };
  },
  watch: {
    'referringProvider.firstName': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_fname: val});
    },
    'referringProvider.lastName': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_lname: val});
    },
    'referringProvider.officePhone': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_officePhone: val});
    },
    'referringProvider.faxNumber': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_fax: val});
    },
    'referringProvider.email': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_email: val});
    },
    'referringProvider.address.line1': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_address: val});
    },
    'referringProvider.address.city': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_city: val});
    },
    'referringProvider.address.state': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_state: val});
    },
    'referringProvider.address.zip': function (val) {
      if (val && val.trim().length) this.changeField({referringProvider_zip: val});
    },
    'referringProvider.noReferringProvider': function (val) {
      let newValue = val ? 'true' : 'false';
      this.changeField({no_referringProvider: newValue});
    },
  },
  created () {
    this.fullscreenLoading = true;
    this.setProgressBar();
    this.setRules(this.fields);
    this.title = this.$route.meta.title;
    this.formTitle = this.$route.meta.formTitle;
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.patientNumber = store.getters.patientData.patientNumber;
    this.sid = this.getSessionId();
    if (!this.patientNumber) {
      this.getDataByPatientNumber().then(() => {
        this.setData();
        this.patientNumber = this.userData.patientNumber;
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    } else {
      this.setData();
    }
  },
  methods: {
    noReferringProvider(value) {
      this.noContact(value);
    },
    changeData(data) {
      this.clearFields(data)
    },
    clearFields(data) {
      this.$set(this, 'referringProvider', {});
      if(data) this.$set(this.referringProvider, 'lastName', data);
      this.$set(this.referringProvider, 'address', {});
      this.keyMask++;
    },
    focusEvent() {
      this.$set(this, 'typingName', this.referringProvider.lastName ? false : true);
    },
    blurEvent() {
      this.$set(this, 'typingName', this.referringProvider.lastName ? true : false);
    },
    changeProvider(data) {
      if (data.value == "Create '" + this.currentQuery + "'") {
        this.$set(this.referringProvider, 'lastName', this.currentQuery);
        this.$set(this.referringProvider, 'address', {});
        this.clearFields(this.currentQuery);
        this.$set(this, 'disableField', false);
      } else {
        if (this.existProviderData.length !== 0 && this.existProviderData[data.index] !== 'undefined') {
          this.$set(this, 'referringProvider', this.existProviderData[data.index]);
          this.keyMask++;
          this.$set(this, 'disableField', true);
        } else {
          this.$set(this.referringProvider, 'lastName', data);
          this.$set(this.referringProvider, 'address', {});
          this.$set(this, 'disableField', false);
        }
      }
    },
    clearProvider() {
      this.$set(this, 'disableField', false);
      this.clearFields();
    },
    searchProviderNames(query, cb) {
      if (query && typeof query !== 'undefined' && query !== this.currentQuery
         || (this.referringProvider.lastName !== '' && typeof this.referringProvider.lastName !== 'undefined' && this.currentQuery !== this.referringProvider.lastName)) {
        this.loading = true;
        this.loadingProvider = true;
        this.currentQuery = query;
        this.$set(this, 'disableField', true);
        this.clearFields(query);
        this.$axios('/Provider/GetReferringProvidersOptions', {
          method: 'GET',
          params: {
            search: query
          }
        }).then((response) => {
          this.$set(this, 'disableField', false);
          if (response.data.isSuccess) {
            if (response.data.data && response.data.data.length !== 0) {
              this.providerNames = response.data.data.map((item, index) => {
                return { value: item.lastName, index: index };
              });
              this.providerNames.push({ value: "Create '" + this.currentQuery + "'", index: this.providerNames.length });
              this.list = this.providerNames;
              cb(this.list);
              this.$refs.autocompleteInput.handleFocus();
              this.existProviderData = response.data.data;
            } else {
              this.list = [{ value: "Create '" + this.currentQuery + "'", index: this.providerNames.length }]
              cb(this.list)
              this.$refs.autocompleteInput.handleFocus();
            }
          } else {
            this.list = [{ value: "Create '" + this.currentQuery + "'", index: this.providerNames.length }]
            cb(this.list)
            this.$refs.autocompleteInput.handleFocus();
          }
          this.loading = false;
          this.loadingProvider = false;
        }).catch(() => {
          this.$set(this, 'disableField', false);
          this.setMessage(this.$t('common.errors.fail'));
          this.fullscreenLoading = false;
        });
      } else {
        cb(this.list);
        this.$refs.autocompleteInput.handleFocus();
      }
    },
    setData() {
      this.saveStatisticData(this.sid, {
        active_step: this.activeStep,
        render_ReferringProvider : 'true'
      });
      this.userData = store.getters.patientData;
      this.updateUserAppData(this.userData.patientId, {
        active_pr_step: this.activeStep,
        active_route: this.$route.name
      });
      this.getStates().then((response) => {
        if (response.data.isSuccess) {
          this.states = response.data.data;
          this.$axios('/Provider/GetReferringProviderByPatientNumber', {
            method: 'GET',
            params: {
              patientNumber: this.userData.patientNumber
            }
          }).then((response) => {
            if (response.data.isSuccess) {
              if (response.data.data) {
                this.$set(this, 'referringProvider', response.data.data);
                if (this.referringProvider.lastName !== '' && typeof this.referringProvider.lastName !== 'undefined') {
                  this.$set(this, 'disableField', true);
                  this.currentQuery = this.referringProvider.lastName;
                }
              } else {
                this.$set(this.referringProvider, 'address', {});
              }
              this.getDataByPatientNumber().then(() => {
                this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
                  pid: store.getters.patientData.patientId
                }).then((response) => {
                  if (response.data) {
                    this.patientNumber = this.userData.patientNumber;
                    this.$set(this.userData, 'practiceId', response.data.appData.practiceId);
                    if (Object.prototype.hasOwnProperty.call(response.data.appData, 'referringProvider')) {
                      this.$set(this.referringProvider, 'noReferringProvider', response.data.appData.referringProvider.noReferringProvider);
                      if (this.referringProvider.noReferringProvider) this.noContact(true);
                    } else {
                      this.$set(this.referringProvider, 'noReferringProvider', false);
                    }
                    this.fullscreenLoading = false;
                  }
                }).catch(() => {
                  this.setMessage(this.$t('common.errors.data'));
                  this.fullscreenLoading = false;
                });
              }).catch(() => {
                this.fullscreenLoading = false;
                this.setMessage(this.$t('common.errors.fail'));
              });
            } else {
              this.fullscreenLoading = false;
              this.setMessage(
                this.$t('common.errors.getInfo', { type: this.$t('preCheckIn.referringProvider.formTitle') }),
                'warning'
              );
            }
          }).catch(() => {
            this.setMessage(this.$t('common.errors.getInfo', { type: this.$t('preCheckIn.referringProvider.formTitle') }));
            this.fullscreenLoading = false;
          });
        } else {
          this.fullscreenLoading = false;
          this.setMessage(this.$t('common.errors.getInfo', { type: this.$t('common.labels.state').toLowerCase() }));
        }
      }).catch(() => {
        this.setMessage(this.$t('common.errors.fail'));
        this.fullscreenLoading = false;
      });
    },
    nextStep() {
      return this.updateStepsData(this.userData.patientId, {[this.activeStep] : 1}).then((response) => {
        if (response.data.isSuccess) {
          let appData = this.updatedUserData;
          appData.noReferringProvider = this.referringProvider.noReferringProvider;
          this.updateUserAppData(this.userData.patientId, {
            referringProvider: appData
          }).then((response) => {
            if (response.data) {
              if (response.data.isSuccess) {
                this.fullscreenLoading = false;
                this.$router.push({
                  name: this.routerName,
                  params: {
                    patientNumber: this.patientNumber
                  },
                });
              } else {
                this.fullscreenLoading = false;
                this.setMessage(
                  this.$t('common.errors.update', { type: this.$t('preCheckIn.referringProvider.formTitle').toLowerCase() }),
                  'warning'
                );
              }
            }
          }).catch(() => {
            this.setMessage(this.$t('common.errors.update', { type: this.$t('preCheckIn.referringProvider.formTitle').toLowerCase() }));
            this.fullscreenLoading = false;
          });
        }
      });
    },
    setUpdatedData() {
      let address = {};
      Object.assign(address, {
        city: this.referringProvider.address.city,
        state: this.referringProvider.address.state,
        line1: this.referringProvider.address.line1,
        zip: this.referringProvider.address.zip,
      });
      this.updatedUserData = {
        patientNumber: this.patientNumber,
        practiceId: this.userData.practiceId,
        firstName: this.referringProvider.firstName,
        lastName: this.referringProvider.lastName,
        email: this.referringProvider.email,
        officePhone: this.referringProvider.officePhone,
        faxNumber: this.referringProvider.faxNumber,
        address: address
      }
    },
    updateReferringProviderData() {
      this.fullscreenLoading = true;
      if (this.referringProvider.providerId) {
        this.$axios('/Provider/updatePatientReferringProvider', {
          method: 'PUT',
          data: {
            patientNumber: this.patientNumber,
            referringProviderId: this.referringProvider.providerId,
            practiceId: this.userData.practiceId,
          }
        }).then((response) => {
          if (response.data.isSuccess) {
            this.setUpdatedData();
            this.nextStep();
          } else {
            this.fullscreenLoading = false;
            this.setMessage(this.$t('common.errors.save', { type: this.$t('preCheckIn.referringProvider.formTitle').toLowerCase() }));
          }
        }).catch(() => {
          this.setMessage(this.$t('common.errors.fail'));
          this.fullscreenLoading = false;
        });
      } else {
        this.setUpdatedData();
        this.$axios('/Provider/CreateReferringProvider', {
          method: 'PUT',
          data: this.updatedUserData
        }).then((response) => {
          if (response.data.isSuccess) {
            this.nextStep();
          } else {
            this.fullscreenLoading = false;
            this.setMessage(this.$t('common.errors.save', { type: this.$t('preCheckIn.referringProvider.formTitle').toLowerCase() }));
          }
        }).catch(() => {
          this.setMessage(this.$t('common.errors.fail'));
          this.fullscreenLoading = false;
        });
      }
    },
    submitForm(formName) {
      this.fullscreenLoading = true;
      if (this.referringProvider.noReferringProvider) {
        this.saveStatisticData(this.sid, {
          submit_ReferringProvider: 'true'
        });
        this.nextStep();
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveStatisticData(this.sid, {
              submit_ReferringProvider: 'true'
            });
            this.updateReferringProviderData();
          } else {
            this.fullscreenLoading = false;
            return false;
          }
        });
      }
    }
  }
};
</script>
